import React from 'react';
import Assessment from './components/Assessment';
export function App() {
  return <div className="min-h-screen bg-gradient-to-br from-indigo-400 to-purple-600 p-5" data-id="element-0">
      <Assessment data-id="element-1" />
    </div>;
}